/*
 * @Author: bianbinbin
 * @Date: 2024-02-02 11:20:11
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-02-02 12:36:02
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/personalInfo.js
 */
const personalInfo = r => require.ensure([], () => r(require('@/views/personalInfo/personalInfo.vue'), 'personalInfo'))

const router = [
  {
    path: '/personalInfo',
    name: 'personalInfo',
    meta: {
      title: '人员信息'
    },
    component: personalInfo
  }
]

export default router
